"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isErrorDtoLike = exports.isApplicationErrorLike = exports.getHttpStatusCodeFromErrorDto = exports.getErrorDto = void 0;
const errors_1 = require("./errors");
const application_error_1 = require("./application_error");
const default_application_error_1 = require("./default_application_error");
__exportStar(require("./error_code_category_enum"), exports);
__exportStar(require("./typings"), exports);
__exportStar(require("./application_error"), exports);
__exportStar(require("./default_application_error"), exports);
__exportStar(require("./already_exists_application_error"), exports);
__exportStar(require("./invalid_argument_application_error"), exports);
__exportStar(require("./internal_application_error"), exports);
__exportStar(require("./not_found_application_error"), exports);
/**
 * Builds an ErrorDto based on the ErrorCode and Record mapping provided in the ApplicationError
 * This ErrorDto is intended to be used as the error body that goes over the wire.
 * @param applicationError - ApplicationError or a duck-typed object that looks like it.
 */
function getErrorDto(applicationError) {
    return {
        errorCode: applicationError.errorType,
        category: applicationError.category,
        statusCode: getHttpStatusCodeFromErrorDto(applicationError.category),
        message: applicationError.message,
    };
}
exports.getErrorDto = getErrorDto;
/**
 * Returns the mapped HTTP Status Code based on the category.
 */
function getHttpStatusCodeFromErrorDto(category) {
    return errors_1.CATEGORY_TO_HTTP_STATUS_CODE_RECORD[category];
}
exports.getHttpStatusCodeFromErrorDto = getHttpStatusCodeFromErrorDto;
/**
 * Determines if the passed in error is ApplicationErrorLike.
 * This returns true if the entity is an instance of the provided ApplicationError, DefaultApplicationError
 * or is a plain object with the properties 'errorType' and 'category'.
 */
function isApplicationErrorLike(error) {
    return (error instanceof application_error_1.ApplicationError ||
        error instanceof default_application_error_1.DefaultApplicationError ||
        (isObject(error) &&
            !isNil(error.errorType) &&
            !isNil(error.category) &&
            !isNil(error.name) &&
            !isNil(error.message)));
}
exports.isApplicationErrorLike = isApplicationErrorLike;
/**
 *
 * @param input Determines if the passed in input looks like an ErrorDto
 */
function isErrorDtoLike(input) {
    return isObject(input) && !isNil(input.category) && !isNil(input.errorCode) && !isNil(input.statusCode);
}
exports.isErrorDtoLike = isErrorDtoLike;
function isObject(val) {
    return !isNil(val) && typeof val === 'object';
}
function isNil(val) {
    return val === null || val === undefined;
}
//# sourceMappingURL=index.js.map